"use client";
import { Gallery, Item } from "react-photoswipe-gallery";
import "photoswipe/dist/photoswipe.css";
import { useEffect, useState } from "react";

const GalleryItem = ({ url, children }: { url: string; children: any }) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setDimensions({
        width: img.width,
        height: img.height,
      });
    };
  }, [url]);

  if (!dimensions.width || !dimensions.height) {
    return null; // Or a loading placeholder
  }

  return (
    <div className="relative">
      <Gallery>
        <Item original={url} width={dimensions.width} height={dimensions.height}>
          {children}
        </Item>
      </Gallery>
    </div>
  );
};
export function FloorplanImage({ url }: { url: string }) {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  return (
    <div className="overflow-hidden w-full max-h-full">
      <div className="p-4">
      <GalleryItem url={url}>
        {({ ref, open }: {ref: any, open: any}) => (
          <img
            ref={ref}
            onClick={open}
            src={url}
            className="w-full h-full object-cover cursor-pointer"
          />
        )}
      </GalleryItem>
      </div>
    </div>
  );
}
